export default __webpack_public_path__ + "static/media/up-arrow.e7f0c54e.svg";